const FLIGHT_MS = 900;
const PULSE_MS = 2000;
const PULSE_CLASS = 'nc_beta-chip__toggle--pulse';

export const prefersReducedMotion = (): boolean =>
  typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const flyTourCardToChip = (card: HTMLElement, chip: HTMLElement, onLanded: () => void): (() => void) => {
  const from = card.getBoundingClientRect();
  const to = chip.getBoundingClientRect();
  const dx = to.left + to.width / 2 - (from.left + from.width / 2);
  const dy = to.top + to.height / 2 - (from.top + from.height / 2);

  card.classList.add('nc_beta-tour__bubble--flying');
  card.style.transform = `translate(${dx}px, ${dy}px) scale(${to.width / from.width})`;

  let hasLanded = false;
  let pulsed = 0;

  const landing = window.setTimeout(() => {
    hasLanded = true;
    chip.classList.add(PULSE_CLASS);
    pulsed = window.setTimeout(() => chip.classList.remove(PULSE_CLASS), PULSE_MS);
    onLanded();
  }, FLIGHT_MS);

  return () => {
    window.clearTimeout(landing);
    if (hasLanded) return;

    window.clearTimeout(pulsed);
    chip.classList.remove(PULSE_CLASS);
  };
};
